import React from 'react';
import { useSelector } from 'react-redux';
import { localeSelector } from 'src/selector/app';
import ReservationPageContent from 'src/consts/poswebsite_content/reservation';
import ProductPage from 'src/components/POSWebsite/Pages/ProductPage';

const Reservation = () => {
  const locale = useSelector(localeSelector);

  return (
    <ProductPage
      pageId={'pos-reservation'}
      pageContent={ReservationPageContent}
      featureCardStyle="border_card"
      whyChowbusShowModel="default"
      // templateMode="loyalty_waitlist"
      customerCaseKeys={[
        `/waitlist/hot-pot/liuyishou-hotpot`,
        '/full-service/xiangs-hunan-kitchen',
        '/sushi-ramen/shinya-ramen-house',
      ]}
    />
  );
};

export default Reservation;

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}
